<template>

	<div class="printView">

		<!-- show loading indicator -->
		<div class="container is-fluid" v-if="isLoading">
			<loading-indicator :loading="isLoading"></loading-indicator>
		</div>

		<template v-if="!isLoading">

			<div class="page" v-for="(product, index) in products">

				<div class="is-clearfix">

					<!-- product PLACEMENT -->
					<template v-if="product.displayType == productDisplayTypes.PLACEMENT.id">
						<product-preview :data="product" :isPrintVersion="true" :settings="{width: 45, isBordered: true, isProportional: true}" :key="product.displayType" class="is-pulled-left"></product-preview>
					</template>

					<!-- product TIPP -->
					<template v-else-if="product.displayType == productDisplayTypes.ADVICE.id">
						<product-tipp-preview :data="product" :isPrintVersion="true" :settings="{width: 45, isBordered: true, isProportional: true}" :key="product.displayType" class="is-pulled-left"></product-tipp-preview>
					</template>

					<!-- show coupons -->
					<template v-for="productVariant in product.productVariants" v-if="productVariant.voucher != null">

						<template v-if="productVariant.voucher != null && productVariant.voucher.preview != null">
							<img class="productVoucherImg is-pulled-right" :src="getImageAsset(productVariant.voucher.preview)" />
						</template>

						<template v-else>
							<coupon :product="product" :isPrintVersion="true" :expirationDates="expirationDates" :productVariant="productVariant" isBordered="true" class="is-pulled-right"></coupon>
						</template>

					</template>

					<!-- show special coupons -->
					<template v-if="product.productVouchers.length > 0">
						<div v-for="(productVoucher, index) in product.productVouchers" :key="index" class="is-pulled-right">
							<coupon :product="product" :isPrintVersion="true" :expirationDates="expirationDates" :productVariant="{ voucher: productVoucher }" :voucherName="productVoucher.title" :voucherPrice='getProductVoucherPrice(product, productVoucher.productVoucherProductVariants)' :voucherSubtitle="productVoucher.subtitle" isBordered="true"></coupon>
						</div>
					</template>

				</div>


				<div class="bottomLine">

					<span class="status">{{ $t('PRODUCTS_PRINT-STATUS-'+product.status.name) }}</span>

					<template v-if="product.lastStatusChange">
						<span class="log">
							<template v-if="product.lastStatusChange.author">
								von <span class="logAuthor">{{ product.lastStatusChange.author }}</span> |
							</template>
							<span class="logDate">{{ formatDate(product.lastStatusChange.created.date )}}</span>
						 </span>
					</template>

				</div>

				<div class="pageNumber">Seite {{ index+1 }}</div>

			</div>

		</template>

	</div>

</template>


<script>
import productPreview from '../catalog/contentElements/contentElementProductPlacement';
import productTippPreview from '../catalog/contentElements/contentElementAdvicePrint';
//import Coupon from './CouponPrint';
import Coupon from './Coupon';

export default {

	name: 'printProducts',

    components: {
		productPreview,
        productTippPreview,
        Coupon
	},

	data() {

		var self = this;

		return {
			isLoading: false,
			products: [],
			expirationDates: []
		}

	},

	created() {

		// get specific product
		if(this.$route.params.productID) {

			this.fetchData({ productId: this.$route.params.productID, filter: null } );

		// product list
		} else {

			// filter present
			if(this.$route.params.filter != '') {
				this.fetchData({ productId: null, filter: this.$route.params.filter} );
			}
			// no filter given
			else {
				this.fetchData({ productId: null, filter: null} );
			}

		}

	},

	computed: {

		productStatus() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_STATUS');
		},

		productDisplayTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_DISPLAY_TYPES');
		},

	},

	methods: {


		getImageAsset(preview) {

			var url = this.$config.assets + preview.path + '/thumb/' + preview.filename;
			// change the extension from *.pdf to *.jpg
			url = url.substr(0, url.lastIndexOf(".")) + ".jpg";

			return url;

		},

		getProductVoucherPrice(product, productVariants) {

			if(productVariants.length > 0 && productVariants[0].productVariant) {

				for(var i= 0; i < product.productVariants.length; i++) {

					if(product.productVariants[i].id == productVariants[0].productVariant) {
						return product.productVariants[i].price;
					}

				}

			} else {

				return product.productVariants[0].price;

			}

		},

		fetchExpirationDates() {

			var self = this;

			this.axios.get(this.$config.api + 'catalog/2?include=catalog.catalogProductVoucherExpirationDates')
				.then(function(response) {
					self.expirationDates = response.data.catalogProductVoucherExpirationDates;
					self.newSpecialCoupon.catalogProductVoucherExpirationDate = self.expirationDates[0];
				}).catch(function(error) {

				});

		},

    fetchData(payload) {

        this.isLoading = true;
        var self = this;
				var url = this.$config.api;

				// get specific product
				if(payload.productId != null) {

					url += 'product?activeProducts=true&productId='+payload.productId+'&orderBy=productVariant.sortorder';

				// get all products (with/without) filters
				} else {

					// if filtering is active
					if(payload.filter != null) {

						if(payload.filter == "inCatalog") {
							url += 'catalogPage?activeProducts=true&customFilter='+payload.filter+'&orderBy=productVariant.sortorder';
						} else {
							url += 'product?activeProducts=true&customFilter='+payload.filter+'&orderBy=productVariant.sortorder';
						}

					// no filter set
					} else {

						url += 'product?activeProducts=true&orderBy=productVariant.sortorder';

					}

				}

        // make the request
        this.axios.get(url)
          .then((response) => {

						// console.log(response.data.activeProducts);

						response.data.activeProducts.forEach((p) => {
							p.productVouchers.forEach((pv) => {
								pv.productVoucherProductVariants.forEach((v) => {
									v.extRef = p.productVariants.find((variant) => variant.id == v.productVariant).extRef;
									// v.extRef = p.productVariants.find((pv) => pv.id == v.productVariant).extRef;
								})
							})
						})


						this.products = response.data.activeProducts;
            this.isLoading = false;

          }).catch((error) => {
              this.isLoading = false;
              console.log('Error: ', error.message);
          });
		},

    }
}
</script>

<style scoped>

	body {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		background-color: #FAFAFA;
		font: 12pt "Tahoma";
	}
	* {
		box-sizing: border-box;
		-moz-box-sizing: border-box;
	}
	.page {
		width: 210mm;
		min-height: 297mm;
		padding: 20mm;
		margin: 10mm auto;
		border: 1px #D3D3D3 solid;
		border-radius: 5px;
		background: white;
		box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
		position: relative;
	}
	.subpage {
		padding: 1cm;
		border: 5px red solid;
		height: 257mm;
		outline: 2cm #FFEAEA solid;
		position: relative;
	}


	@page {
		size: A4;
		margin: 0;
	}

	@media print {
		html, body {
			margin: 0 !important;
			width: 210mm;
			height: 297mm;
			background-color: #fff;
			/*background-color: transparent;*/
			-webkit-print-color-adjust: exact;
		}
		.page {
			background-color: #fff;
			/*background-color: transparent;*/
			margin: 0;
			border: initial;
			border-radius: initial;
			width: initial;
			min-height: initial;
			box-shadow: initial;
			background: initial;
			page-break-after: always;
			position: relative !important;
			 -webkit-print-color-adjust: exact;
		}
		.printView {
			width: 100%;
			height: 100vh;
			position: relative;
			background-color: #fff;
			 -webkit-print-color-adjust: exact;
		}
		.printView .bottomLine {
			bottom: 0 !important;
		}
		.printView .pageNumber {
			bottom: 0 !important;
		}

	}

	.printView ul {
		width: 590px !important;
		margin: 0 auto;
		padding: 0;
	}
	.printView ul li {
		position: relative;
		width: 100%;
		height: auto;
		margin: 10px 0;
		padding: 0;
	}
	.printView ul li .columns {
		margin: 0;
		padding: 0;
	}
	.printView .bottomLine {
		position: absolute;
		bottom: 22mm;
		left: 22mm;
		right: 22mm;
		height: auto;
	}
	.printView .bottomLine .status {
		text-transform: uppercase;
		font-weight: 500;
		display: block;
	}
	.printView .bottomLine .log {
		font-size: 12px;
	}
	.printView .bottomLine .logAuthor {
		font-weight: 400;
	}
	.printView .bottomLine .logDate {
		font-weight: 400;
	}

	.printView .pageNumber {
		position: absolute;
		bottom: 22mm;
		left: auto;
		right: 22mm;
		text-align: right;
		width: 100px;
		height: auto;
		font-size: 14px;
	}
	.printView .productVoucherImg {
		margin: 0 0 15px 0;
		width: 300px;
	}
</style>
